import * as PermissionTypes from '@/store/permissionTypes'

export default {
  created() {
    this.PermissionTypes = PermissionTypes    
  },
  methods: {
    // Check if the logged in user has permissions to create a resource
    userHasCreatePermission(resourceType) {
      return this.userHasPermission('create', resourceType)
    },

    // Check if the logged in user has permissions to read a resource
    userHasReadPermission(resourceType) {
      return this.userHasPermission('read', resourceType)
    },

    // Check if the logged in user has permissions to update a resource
    userHasUpdatePermission(resourceType) {
      return this.userHasPermission('update', resourceType)
    },

    // Check if the logged in user has permissions to delete a resource
    userHasDeletePermission(resourceType) {
      return this.userHasPermission('delete', resourceType)
    },

    isPermissionDataLoaded() {
      if(this.$store.state.profile.permissionMap && Object.keys(this.$store.state.profile.permissionMap).length > 0)
        return true
      return false
    },

    // General permission check for an action/resource combo
    userHasPermission(accessType, resourceType) {
      try {
        if(this.$store.state.profile.permissionMap[resourceType] == undefined)
          return false
        if(this.$store.state.profile.permissionMap[resourceType][accessType] == undefined)
          return false
        return this.$store.state.profile.permissionMap[resourceType][accessType].result == 'allow'
      } catch {
        return false
      }
    }
  }
}
